import assets from '@/services/asset';
import {
  genericCreate as gc,
  genericFind as gf,
  genericGet as gg,
  genericRemove as gr,
} from '@/services/gql';

export const genericCreate = (tableName: string) => {
  const query = gc(tableName);
  return (objects: any) => (
    query({ objects })
      .then(response => response.table.returning[0])
  );
};

interface IFindOpts {
  limit?: number;
  offset?: number;
  orderBy?: {
    [field: string]: string;
  };
  where?: {
    [field: string]: any;
  };
}

export const genericFind = (
  tableName: string,
) => <QueryResult>(
  returnFields: string,
  opts = {} as IFindOpts,
) => (
  gf<QueryResult>(tableName, returnFields)({
    limit: 1000,
    offset: 0,
    orderBy: {
      name: 'asc',
    },
    ...opts,
  })
  .then(response => ({
    count: response.aggregate.aggregate.count,
    result: response.table,
  }),
));

interface GetResult<Fields> {
  table: Fields;
}

export const genericGet = (
  tableName: string,
) => <QueryResult>(
  id: string,
  returnFields: string,
) => (
  gg<GetResult<QueryResult>>(tableName, returnFields)({
    id,
  }).then(response => {
    const [result] = response.table;
    if (result) {
      return result;
    }
    throw {
      code: `${tableName.toUpperCase()}_NOT_FOUND`,
    };
  })
);

export const genericRemove = (tableName: string) => {
  const remove = gr(tableName);
  return (id: string) => (
    remove({ id }).then(response => {
      if (!response.table.affected_rows) {
        throw {
          code: `${tableName.toUpperCase()}_NOT_DELETED`,
        };
      }

      // remove all related assets if any returned
      const { affected_rows, returning } = response.assets;
      affected_rows && assets.remove({
        ids: returning.map(row => row.id),
      });

      return response;
    })
  );
};
